import React from 'react';
import { Link } from 'react-router-dom';

const SERVICES = [
  { img:'https://images.unsplash.com/photo-1555066931-4365d14bab8c?w=800&auto=format&fit=crop&q=70', label:'MERN Stack', title:'Web Applications', sub:'React · Node · MongoDB', desc:'Full-stack JavaScript platforms built for performance and scale.' },
  { img:'https://images.unsplash.com/photo-1517694712202-14dd9538aa97?w=800&auto=format&fit=crop&q=70', label:'Full Stack Java', title:'Enterprise Systems', sub:'Spring Boot · Microservices', desc:'Robust, enterprise-grade backends handling millions of transactions.' },
  { img:'https://images.unsplash.com/photo-1526379095098-d400fd0bf935?w=800&auto=format&fit=crop&q=70', label:'Python', title:'Intelligent Apps', sub:'Django · FastAPI · ML/AI', desc:'Data-driven products powered by machine learning and automation.' },
  { img:'https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=800&auto=format&fit=crop&q=70', label:'Flutter', title:'Mobile Experiences', sub:'iOS · Android · Cross-platform', desc:'Pixel-perfect apps with native performance from one codebase.' },
  { img:'https://images.unsplash.com/photo-1432888622747-4eb9a8efeb07?w=800&auto=format&fit=crop&q=70', label:'Digital Marketing', title:'Growth Strategies', sub:'SEO · PPC · Content', desc:'Data-led campaigns that build brand presence and convert audiences.' },
  { img:'https://images.unsplash.com/photo-1510511459019-5dda7724fd87?w=800&auto=format&fit=crop&q=70', label:'Cyber Security', title:'Digital Protection', sub:'VAPT · SOC · Compliance', desc:'Comprehensive audits and real-time monitoring to keep you safe.' },
];

const ServicesPreview = () => (
  <section style={{
    backgroundImage:`url('https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1800&auto=format&fit=crop&q=60')`,
    backgroundSize:'cover', backgroundAttachment:'fixed', backgroundPosition:'center',
    position:'relative',
  }}>
    <div style={{ position:'absolute', inset:0, background:'rgba(28,21,16,0.88)' }} />
    <div className="container position-relative section-pad" style={{ zIndex:1 }}>
      <div className="row align-items-end mb-5">
        <div className="col-lg-6">
          <span className="section-label">Services</span>
          <h2 className="section-title">Design That<br/><em>Resonates</em></h2>
        </div>
        <div className="col-lg-6 d-flex justify-content-lg-end align-items-end mt-3 mt-lg-0">
          <div>
            <p className="section-sub mb-4">We offer more than code — we craft experiences through clarity, texture, intention and thoughtful presence.</p>
            <Link to="/services" className="btn-warm"><span>View All Services</span>
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M1 7h12M8 2l5 5-5 5" stroke="currentColor" strokeWidth="1.2"/></svg>
            </Link>
          </div>
        </div>
      </div>

      {/* Grid: 3 col */}
      <div className="row g-0" style={{ border:'1px solid var(--border)' }}>
        {SERVICES.map((s, i) => (
          <div key={i} className="col-lg-4 col-md-6" style={{ borderRight: i%3===2 ? 'none':'1px solid var(--border)', borderBottom: i<3 ? '1px solid var(--border)':'none' }}>
            <div className="warm-card" style={{ border:'none', borderRadius:0, height:'100%' }}>
              <div style={{ overflow:'hidden', height:200 }}>
                <img src={s.img} alt={s.title} className="warm-card-img" style={{ height:200, aspectRatio:'unset' }} />
              </div>
              <div style={{ padding:'28px 26px 32px' }}>
                <span style={{ fontFamily:'var(--font-body)', fontSize:'0.65rem', letterSpacing:'0.22em', textTransform:'uppercase', color:'var(--tan)', display:'block', marginBottom:10 }}>{s.label}</span>
                <h4 style={{ fontFamily:'var(--font-disp)', fontSize:'1.55rem', fontWeight:400, marginBottom:6, color:'var(--cream2)' }}>{s.title}</h4>
                <p style={{ fontFamily:'var(--font-body)', fontSize:'0.72rem', letterSpacing:'0.12em', color:'var(--tan2)', marginBottom:14, textTransform:'uppercase' }}>{s.sub}</p>
                <p style={{ color:'var(--muted)', fontSize:'0.85rem', lineHeight:1.75, fontWeight:300 }}>{s.desc}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default ServicesPreview;
